import "./index.scss";

import { Box, Stack } from "@mui/material";
import ScreenLoader from "components/ScreenLoader";
import * as authActions from "modules/auth/authActions";
import { memo, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";

const LoginPageComponent = () => {
  //console.log("In LoginPageComponent.");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const error = useAppSelector((state) => state.auth.error);
  const { pathname } = location;

  const token = useMemo(() => {
    let splits = pathname.split("/").filter((data) => !!data);
    if (splits.length === 3) {
      return `${splits[1]}/${splits[2]}`;
    } else if (splits.length === 2) {
      return `${splits[1]}`;
    }
    return "";
  }, [pathname]);

  useEffect(() => {
    //console.log("In loginpage index. Token is %s", token);
    if (!!token) {
      dispatch(authActions.login({ successCallback, token }));
    }
  }, [token]);

  const successCallback = () => {
    navigate("/message-center");
  };

  return (
    <Box display="flex" flex={1} height="100vh" justifyContent="center" alignItems="center">
      {token && !error ? (
        <ScreenLoader isScreenLoader />
      ) : (
        <Stack justifyContent="center" alignItems="center">
          <img
            alt="login-illustration"
            src={require("assets/images/ui/login-illustration.png")}
            width="500px"
            height="500px"
          />
          <h1>Please login first !</h1>
        </Stack>
      )}
    </Box>
  );
};

const LoginPage = memo(LoginPageComponent);
export default LoginPage;
